import axiosPost from "../axiosPost";

export const SFHotelAdminDel = async (
    params = {},
    credentials
) => {
    const body = {
        service: "SFHotelAdminDel",
        params: {
            msuAdicionalId: params?.msuAdicionalId
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
